import { render, staticRenderFns } from "./DataFechamento.vue?vue&type=template&id=07cc7632&"
import script from "./DataFechamento.vue?vue&type=script&lang=js&"
export * from "./DataFechamento.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports